import { Constants } from "../constants"

class BaseLoader {
    constructor() {
        this.isLoading = true
        this.hasError = false
        this.error = undefined
    }
}

class ScreenLoader extends BaseLoader {
    constructor() {
        super()
        this.filter = new BaseLoader()
        this.locations = new BaseLoader()
        this.customer = new BaseLoader()
        this.region = new BaseLoader()
        this.groups = new BaseLoader()
        this.entity = new BaseLoader()
    }

    start(loaders) {
        this.isLoading = true
        this.error = undefined
        if (loaders == undefined) {
            this.hasError = false
            for (const property in this) {
                if (this[property] instanceof BaseLoader) {
                    this[property].isLoading = false
                    this[property].hasError = false
                }
            }
        } else {
            for (const loader of loaders) {
                this[loader].isLoading = true
                this[loader].hasError = false
            }
        }
    }

    stop(loaders) {
        this.isLoading = false
        this.hasError = false
        this.error = undefined
        if (loaders == undefined) {
            for (const property in this) {
                if (this[property] instanceof BaseLoader) {
                    this[property].isLoading = false
                    this[property].hasError = false
                }
            }
        } else {
            for (const loader of loaders) {
                this[loader].isLoading = false
                this[loader].hasError = false
            }
        }
    }

    stopWithError(error, loaders) {
        console.log('Error code: ', error.errorCode)
        console.log('Error message: ', error.message)
        console.log(error)
        this.isLoading = false
        this.error = error
        if (loaders == undefined) {
            this.isLoading = false
            this.hasError = true
            for (const property in this) {
                if (this[property] instanceof BaseLoader) {
                    this[property].isLoading = false
                }
            }
        } else {
            for (const loader of loaders) {
                this[loader].isLoading = false
                this[loader].hasError = true
            }
        }
    }

    stopWithAlert(store, error, loaders) {
        console.log('Error code: ', error.errorCode)
        console.log('Error message: ', error.message)
        this.stop(loaders)

        store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: error.errorCode, message: Constants[error.message.result]})
    }
}

const LoadingUtil = {

}

export { LoadingUtil, ScreenLoader }